export default "__VITE_ASSET__DSsLdR8m__"